import { render, staticRenderFns } from "./UploadDossier.vue?vue&type=template&id=fda9f586&scoped=true&"
import script from "./UploadDossier.vue?vue&type=script&lang=js&"
export * from "./UploadDossier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda9f586",
  null
  
)

export default component.exports